/**
 * Página 404 específica para rutas retiradas del módulo de Postventa.
 * Se monta en /solicitudes y /configuracion (hoy fuera del sidebar IBC).
 * Indica al usuario que la funcionalidad migró a otra plataforma.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

const PostventaRetiredPage = () => (
  <div className="max-w-2xl mx-auto mt-8 lg:mt-16" data-testid="page-postventa-retired">
    <div className="bg-white border border-[#E8E8E7] rounded-lg p-6 lg:p-10 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-[#FAF8F6] rounded-full mb-4">
        <AlertTriangle size={32} className="text-[#9d8272]" />
      </div>
      <h1 className="text-2xl font-bold text-[#2D2D2D] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
        Esta sección ya no está disponible aquí
      </h1>
      <p className="text-sm text-[#5A5A5A] mb-1">
        El módulo de Postventa ha sido migrado fuera de <strong>Business Central (IBC)</strong>.
      </p>
      <p className="text-sm font-medium text-[#9d8272] mb-6">
        Debe ingresar a la plataforma App Web de Postventa.
      </p>
      <Link to="/home">
        <Button className="bg-[#9d8272] hover:bg-[#876a58] text-white" data-testid="btn-ir-home">
          <Home size={16} className="mr-2" />
          Volver al inicio de IBC
        </Button>
      </Link>
    </div>
  </div>
);

export default PostventaRetiredPage;
